import { render, staticRenderFns } from "./SearchTasks.vue?vue&type=template&id=94447534&scoped=true"
import script from "./SearchTasks.vue?vue&type=script&lang=js"
export * from "./SearchTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94447534",
  null
  
)

export default component.exports